import { useNavigate } from "react-router-dom";
import {
  ENDOMETRIAL_BIOPSY,
  INTRA_UTERINE_DEVICE_INSERTION,
  ROUTINE_PESSARY_CARE,
  VULVA_PUNCH_BIOPSY,
} from "navigation/Paths";
import { Stack, Text, UnstyledButton } from "@mantine/core";

export const ModulesList = () => {
  const navigate = useNavigate();
  const modules = [
    {
      title: "Endometrial Biopsy/Aspiration",
      path: ENDOMETRIAL_BIOPSY,
      disabled: false,
    },
    {
      title: "Intrauterine Device/System (IUD/IUS) Insertion",
      path: INTRA_UTERINE_DEVICE_INSERTION,
      disabled: false,
    },
    {
      title: "Punch Biopsy of Vulva",
      path: VULVA_PUNCH_BIOPSY,
      disabled: false,
    },
    {
      title: "Routine Pessary Care",
      path: ROUTINE_PESSARY_CARE,
      disabled: false,
    },
  ];
  return (
    <Stack>
      {modules.map((module) => (
        <UnstyledButton
          disabled={module.disabled}
          onClick={() => navigate(module.path)}
        >
          <Text>{module.title}</Text>
        </UnstyledButton>
      ))}
    </Stack>
  );
};
